import axios from "axios";

const api = axios.create({
  baseURL: 'https://api.track-mfg.mimiq.io',
  //baseURL: 'http://localhost:3000',
  timeout: 30000,
  headers: { Accept: "*", "Access-Control-Allow-Origin": "*","Access-Control-Allow-Headers":"Origin, X-Requested-With, Content-Type, Accept" },
  
});

let navigateFunction = null;
export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // JWT ile ilgili hatalar (401 Unauthorized)
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt');
      if (navigateFunction) {
        navigateFunction('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default api;

